import * as React from 'react';
import * as Redux from 'react-redux';
import ContainerTemplate from '../../../../widgets/template/Container';
import PlanEvaluacionView from './PlanEvaluacionView';
import * as ROUTES from '../../../../router/Routes';

const PlanEvaluacionModule = () => {
  const loginStore = Redux.useSelector((state) => state.login);

  const admin = [ROUTES.controlEstudios];
  const teacher = [ROUTES.academico];

  return (
    <ContainerTemplate
      active={ROUTES.planEvaluacion}
      routes={loginStore.isAdmin ? admin : teacher}
    >
      <PlanEvaluacionView />
    </ContainerTemplate>
  );
};

export default PlanEvaluacionModule;
